// @flow

export const MODEL = 'Accounts'

// Api End Point
export const URL = 'hefty/createuser/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_USERNAME = 'username'
export const PROP_PASSWORD = 'password'
export const PROP_PASSWORD_CONFIRM = 'password_confirm'
export const PROP_FIRST_NAME = 'first'
export const PROP_LAST_NAME = 'last'
export const PROP_FARM_NAME = 'farm_name'
export const PROP_EMAIL = 'email'
export const PROP_COUNTRY = 'country'
export const PROP_ADDRESS = 'address'
export const PROP_POSTAL_CODE = 'postal_code'
export const PROP_CITY = 'city'
export const PROP_PROVINCE = 'province'
export const PROP_PHONE = 'phone'
export const PROP_MOBILE_PHONE = 'mobile_phone'
export const PROP_FAX = 'fax'
export const PROP_DEFAULT_UNITS = 'units'
export const PROP_AREA = 'area'

export const MIN_SIZE_PASSWORD = 8
export const VALID_USERNAME_TEXT_PATTERN = /^[a-zA-Z0-9-.+@_]*$/

export const PROP_SUBJECT = 'Subject'
export const PROP_MESSAGE = 'Message'
export const PROP_NAME = 'Name'
